<template>
	<div class="copy-field" :class="{outline}">
		<div v-if="text" class="copy-field__text" data-scroll-lock-scrollable><span class="copy-field__text-inner">{{text}}</span></div>
		<div v-else class="copy-field__placeholder">{{placeholder}}</div>
		<button @click="copyText" class="copy-field__btn">
			<svg class="copy-field__btn-icon"><use href="#svg-icon-copy"></use></svg>
		</button>
	</div>
</template>

<script>

export default {
	props: {
		text: {
			type: [String, Number],
			default: null
		},

		value: {
			type: [String, Number],
			default: null
		},

		message: {
			type: String,
			default: 'Успешно скопировано!'
		},

		placeholder: {
			type: String,
			default: null
		},

		outline: {
			type: Boolean,
			default: false
		},
	},

	methods: {
		copyText() {
			navigator.clipboard.writeText(this.value || this.text);
			if (this.message) {
				this.$toast.success(this.message);
			}
		}
	}
}

</script>